import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FilterModel, OperatorFilterEnum } from 'app/models/filter-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { Utils } from '../../utils/Utils';
import * as moment from 'moment-timezone';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, forkJoin, map, Observable, of, switchMap, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserModel } from 'app/models/user';
import { MassiveActions } from 'app/components/shared/filters/filter.component';
import { DataTicketProductModel } from '../../../models/data-ticket-model';
import { InvoiceAdminModel } from 'app/models/invoice-admin-model';
import { InvoiceDetailsAdminModel } from 'app/models/invoice-details-admin-model';
import { Log } from 'app/core/logging/log';
import { DataTableSelectionConfig } from 'app/components/shared/data-table/data-table.component';
import { DataTableBadgeTone } from 'app/components/shared/data-table/data-table-badge.component';


@Component({
  selector: 'app-admin-invoice',
  templateUrl: './admin-invoice.page.html',
  styleUrls: ['./admin-invoice.page.scss'],
})
export class AdminInvoicePage implements OnInit {

  state: 'idle' | 'loading' | 'loaded' | 'error' = 'idle';
  payments: {
    content: InvoiceAdminModel[],
    pageNumber: number,
    totalElements: number,
    size: number,
    last: boolean
  } = { totalElements: 50, size: 0, pageNumber: 0, last: false, content: [] };
  resumen: any = {};
  totalElements: number = 50;
  pageSize = 10;
  pageIndex = 0;

  fieldFilters: any[] = [];
  accions: string[] = [];
  massiveAccions: MassiveActions[] = [
    { key: 'convert_invoices', enabled: false }
  ];

  massiveActionSelected: string = '';

  dataSource = new MatTableDataSource<InvoiceAdminModel>;
  displayedColumns = ['select', 'invoiceNumber', 'type', 'idClient', 'createdAt'];
  selection = new SelectionModel<InvoiceAdminModel>(true, []);
  readonly selectionColumnConfig: DataTableSelectionConfig<InvoiceAdminModel> = {
    selection: this.selection,
    canSelect: (row) => this.validationRow(row)
  };
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private restService: RestService,
    public appService: AppService) { }

  ngOnInit() {
    this.fieldFilters.push({
      name: 'type',
      type: 'select',
      multiple: false,
      value: '',
      values: [],
      options: ['SIMPLIFICADA', 'COMPLETA'],
      label: this.appService.getTraduccion('finance.invoice.searcher.type')
    });
    this.fieldFilters.push({
      name: 'createdAt',
      type: 'date',
      multiple: false,
      value: '',
      values: [moment().subtract(1, 'M').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      options: null,
      label: this.appService.getTraduccion('finance.invoice.searcher.createdAt')
    });
    this.fieldFilters.push({
        name: 'customerId',
        label: this.appService.getTraduccion('finance.invoice.searcher.customerId'),
        type: 'user-search',
        multiple: false,
        value: '',
        values: [],
        options: [],
        searchField: 'email',
        noDataLabel: 'finance.payment.assing.selectedUser.nodata',
        placeholder: 'Ej. Ana, ana@correo.com, +34...'
    });
    /*this.fieldFilters.push({
      name: 'customerId',
      type: 'number',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.invoice.searcher.customerId')
    });*/
    this.fieldFilters.push({
      name: 'telephoneNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.invoice.searcher.telephoneNumber')
    });
    this.fieldFilters.push({
      name: 'email',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.invoice.searcher.email')
    });
    this.fieldFilters.push({
      name: 'invoiceNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.invoice.searcher.invoiceNumber')
    });
    this.fieldFilters.push({
      name: 'ticketNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('finance.invoice.searcher.ticketNumber')
    });

    this.accions = ["ZIP", "EXCEL"]

    this.selection.changed.subscribe(rows => {
      if (rows.source.isEmpty()) {
        this.massiveAccions.forEach(accion => accion.enabled = false);
      } else {
        this.massiveAccions.forEach(accion => accion.enabled = true);
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  /** Header checkbox helpers */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.validationRow(row) && this.selection.select(row));
  }

  openModal(invoice: InvoiceAdminModel) {
    const isNew: boolean = invoice.invoiceNumber == undefined ? true : false;
    let dialogRef = this.dialog.open(InvoiceModalContent, {
      panelClass: 'responsive-dialog',
      data: { invoice: invoice, isNew: isNew }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchInvoices());
  }


  generateInvoiceModal() {
    let dialogRef = this.dialog.open(InvoiceConvertInvoiceModalContent, {
      panelClass: 'responsive-dialog',
      data: { selectedRows: this.selection.selected }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchInvoices());
  }



  /**
   * 
   * @param event example: { length: 155, pageIndex: 1, pageSize: 50, previousPageIndex: 0 }
   */
  onPageChange(event: PageEvent) {
    Log.debug('onPageChange', {event});

    const page = event ? event.pageIndex : this.pageIndex;
    const size = event ? event.pageSize : this.pageSize;

    this.searchInvoices({action: 'PAGE_CHANGE', page: page, size: size});
  }

  onClickMassiveAction(value: string) {
    if (value == 'convert_invoices') {
      this.generateInvoiceModal();
    } else {
      alert('error, acción no seleccionada');
    }
  }

  onChangeMassiveActionSelected(value: string) {
    this.massiveActionSelected = value;
  }

  validationRow(invoice: InvoiceAdminModel): boolean {
    if (this.massiveActionSelected == 'convert_invoices') {
      return invoice.type == 'SIMPLIFICADA';
    } else {
      return false;
    }
  }

  setOpen(invoice?: InvoiceAdminModel) {
    this.openModal(Object.assign({}, invoice));
  }


  mapAsFilters(fieldFilters: any[]):string {
    let filters = [];
    let map = [];
    map['date'] = OperatorFilterEnum.BETWEEN;
    map['datetime'] = OperatorFilterEnum.BETWEEN;
    map['time'] = OperatorFilterEnum.BETWEEN;
    map['text'] = OperatorFilterEnum.EQUALS;
    map['select'] = OperatorFilterEnum.EQUALS;
    map['number'] = OperatorFilterEnum.EQUALS;
    map['user-search'] = OperatorFilterEnum.EQUALS;
    
    for (let fieldFilter of fieldFilters) {
      if ((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)) {
        let values:string[] = [...fieldFilter.values]
        if (fieldFilter.name == 'createdAt') {
          values = Utils.mapLocalDateRangeToUtc(values);
        }
        filters.push({
          field: fieldFilter.name,
          operator: map[fieldFilter.type],
          value: fieldFilter.value,
          values: values
        });
      }
    }
    return Utils.generateFilters(filters);
  }

  submit(action:string){
    this.searchInvoices({action: action});
  }

  searchInvoices({ page=this.pageIndex, size=this.pageSize, action=null }: { page?: number; size?: number; action?: string; } = {}) {
    Log.debug('searchInvoices', { page:this.pageIndex, size:this.pageSize, action:action });

    let filters = this.mapAsFilters(this.fieldFilters);
    filters += (filters != null && filters != '') ? ',' : '';
    filters += 'invoiceNumber;IS_NULL;false';

    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + page + '&size=' + size;

    if (action == null || action == 'PAGE_CHANGE') {
      this.restService.searchInvoices(filters + sort + pageSize).subscribe(result => {
        this.state = 'loaded';
        this.payments = result;
        this.dataSource.data = result.content;
        this.totalElements = result.totalElements;     // total global
        //this.pageSize = result.pageSize;               // tamaño actual
        this.pageIndex = result.pageNumber;            // índice actual
        this.selection.clear();
      }, err => {
        this.state = 'error';
      });

      if (action == null) {
        this.restService.getResumenInvoices(filters + sort).subscribe(result => {
          this.resumen = result;
        });
      }

    } else {
      this.download(action);
    }
  }

  download(type: string = 'ZIP|EXCEL') {
    Log.debug('download', {type})
    if (type == null) {
      return;
    }
    if (type == 'ZIP') {
      this.getInvoiceZip();
    } else {
      this.getReport();
    }
  }

  getReport() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + this.payments.pageNumber + '&size=' + this.totalElements;

    this.restService.getInvoiceReport(filters + sort + pageSize).subscribe(response => {
      let filename = `report-${this.mapAsDate('createdAt')[0]}_${this.mapAsDate('createdAt')[1]}`;
      let dataType = response.type;
      let binaryData = [];
      binaryData.push(response);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
      if (filename){
        downloadLink.setAttribute('download', filename);
      }
      document.body.appendChild(downloadLink);
      downloadLink.click();
    });
  }

  getInvoiceZip() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + this.payments.pageNumber + '&size=' + this.totalElements;

    this.restService.getInvoiceZip(filters + sort + pageSize).subscribe(response => {
      var blob = new Blob([response], { type: response.type.toString() });
      var url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = `invoices-${this.mapAsDate('createdAt')[0]}_${this.mapAsDate('createdAt')[1]}.zip`;
      anchor.href = url;
      anchor.click();
    });
  }

  totalFacturado() {
    let sum = 0;
    this.payments.content.forEach(invoice => {
      sum += invoice.totalPrice;
    });
    return sum;
  }

  mapAsDate(fieldName: string): string[] {
    let field = this.fieldFilters.find(i => i.name == fieldName);
    if (field.values) {
      return field.values;
    }
  }

  getInvoiceTypeTone(type?: string): DataTableBadgeTone {
    return type === 'SIMPLIFICADA' ? 'warning' : 'success';
  }

}

@Component({
  selector: 'app-admin-invoice-modal-content',
  templateUrl: './admin-invoice-modal.component.html',
  styleUrls: ['./admin-invoice-modal.component.scss']
})
export class InvoiceModalContent implements OnInit {

  invoice: InvoiceDetailsAdminModel;

  cols: (keyof DataTicketProductModel | 'tax')[] = ['name', 'amount', 'basePrice', 'tax', 'total'];
  dataSource = new MatTableDataSource<DataTicketProductModel>([]);
  totals = { qty: 0, base: 0, tax: 0, total: 0 };

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { invoice: InvoiceAdminModel },
    public dialogRef: MatDialogRef<InvoiceModalContent>,
    private restService: RestService,
    public appService: AppService
  ) {

  }

  ngOnInit(): void {
    this.getInvoice();
  }

  getInvoice() {
    this.restService.getInvoice(this.data.invoice.invoiceNumber).subscribe((result: InvoiceDetailsAdminModel) => {
      this.invoice = result;
      const products = ((result as any)?.paymentOrRefund?.dataTicket?.products || (result as any)?.paymentOrRefund?.cart?.items || []) as DataTicketProductModel[];
      this.dataSource.data = products.map(r => ({
        ...r,
        tax: '21%'
      }));
      this.totals.base = this.invoice.paymentOrRefund.basePrice;
      this.totals.tax = this.invoice.paymentOrRefund.taxPrice;
      this.totals.total = this.invoice.paymentOrRefund.totalPrice;
    });
  }

  convertToFull() {
    let dialogRef = this.dialog.open(InvoiceConvertInvoiceModalContent, {
      panelClass: 'responsive-dialog',
      data: { selectedRows: [this.invoice] }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.getInvoice());
  }

  print() { window.print(); }

  downloadPdf() {

    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.getInvoiceBase64(this.invoice.invoiceNumber).subscribe(result => {
      let pdfWindow = window.open("");
      pdfWindow.document.write(
        "<head><title>Invoice " + this.invoice.paymentOrRefund.ticketNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )
    });
  }

  sendByEmail() { /* POST /invoices/{id}/send-email */ }

  close() {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'app-invoice-convert-invoice-modal-content',
  templateUrl: './invoice-convert-invoice-modal.component.html',
  styleUrls: ['./invoice-convert-invoice-modal.component.scss']
})
export class InvoiceConvertInvoiceModalContent {

  selectedRows: InvoiceAdminModel[];
  dataSource = new MatTableDataSource<InvoiceAdminModel>;
  displayedColumns = ['invoiceNumber', 'type', 'idClient', 'createdAt'];
  searchCtrl = new FormControl<string | UserModel>('');
  users$!: Observable<UserModel[]>;
  loading$ = new BehaviorSubject<boolean>(false);
  assigning$ = new BehaviorSubject<boolean>(false);
  selectedUser: UserModel | null = null;

  selectedCount: number = 0;
  totalAmount: number = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private snack: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { selectedRows: InvoiceAdminModel[] },
    public dialogRef: MatDialogRef<InvoiceConvertInvoiceModalContent>,
    private restService: RestService,
    public appService: AppService
  ) {
    this.selectedRows = data.selectedRows;
    this.dataSource = new MatTableDataSource(this.selectedRows);
    this.users$ = this.searchCtrl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.loading$.next(true)),
      switchMap(value => {
        const term = typeof value === 'string' ? value : value?.username ?? '';
        if (!term || term.trim().length < 2) { this.loading$.next(false); return of([]); }

        let filters: FilterModel = {
          field: 'email',
          operator: OperatorFilterEnum.LIKE,
          value: term
        }

        return this.restService.searchUsers(Utils.generateFilters(Array(filters))).pipe(
          map((result) => result.content),
          catchError(() => of([])),
          tap(() => this.loading$.next(false))
        );
      })
    );

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  displayUser = (u?: UserModel) => (u ? `${u.username} · ${u.email}` : '');

  onPick(u: UserModel, ev: any) {
    if (ev?.isUserInput) this.selectedUser = u;
    Log.debug('onPick', {selectedUser: this.selectedUser, u});
  }

  onChangeMode() {

  }


  clear() {
    this.searchCtrl.setValue('');
    this.selectedUser = null;
  }

  close() {
    this.dialogRef.close();
  }

  convertInvoiceMassive() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    const peticiones = this.selectedRows.map(invoice => {
      Log.debug('paymentToAssing', {selectedUserId: this.selectedUser.id, invoice});
      return this.restService.convertInvoice(invoice.paymentOrRefund.uuid, invoice.invoiceNumber, this.selectedUser.id).pipe(
        map(res => ({ invoice: invoice, ok: true })),
        catchError(err => of({ invoice: null, ok: false }))
      );
    });

    forkJoin(peticiones).subscribe((results: { ok: boolean, invoice: InvoiceAdminModel }[]) => {
      Log.debug('Todas las respuestas:', {results});
      const updated:boolean = results?.some(r => r.ok === true) ?? false;
      for (let result of results) {
        if (result.ok) {
          this.appService.showSuccessToast(`Las factura ${result.invoice.invoiceNumber} se han convertido correctamente`);
        }
      }
      this.dialogRef.close({ updated: updated });
    });

  }

}
